import React from "react";
import clsx from "clsx";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Badge from "@material-ui/core/Badge";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import useStyles from "../Layout/styles";
import Avatar from "@material-ui/core/Avatar";
import logo from "../Assets/logo.png";

import {
  Menu as MenuIcon,
  Notifications as NotificationsIcon,
  NotificationsActive as NotificationsActiveIcon,
} from "@material-ui/icons";
import theme from "../Themes";

export default function Navbar(props) {
  const classes = useStyles();

  // TODO: pass avatar image here:
  const avatarImage = false;
  // "https://source.unsplash.com/400x400/?portrait";

  // TODO: pass notification number here:
  const notifications = 0;

  const company = {
    logo: logo,
    name: "PRENOTAM - Richiesta Abbonamento",
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      className={clsx(classes.appBar, {
        [classes.appBarShift]: props.open,
        [classes.absOpacity]: props.open,
      })}
    >
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={props.handleDrawerOpen}
          edge="start"
          className={clsx(classes.menuButton, {
            [classes.hide]: props.open,
          })}
        >
          <MenuIcon />
        </IconButton>
        {company.logo ? (
          <div className={classes.logoBox}>
            <img className={classes.logo} src={company.logo} alt="logo" />
          </div>
        ) : (
          <Typography className={classes.title} variant="h2" noWrap>
            {company.name}
          </Typography>
        )}
      </Toolbar>
    </AppBar>
  );
}
